import React, { useRef } from "react"
import { api } from "apiServer"
import { Layout } from "components/common"
import SwiperVideo from "components/SwiperVideo"
import { useEffect, useState } from "react"
import classNames from "classnames"
import CardHorizontal from "components/TypeCard/CardHorizontal"
import { getAccessToken } from "lib/Cookies"

const PAGE_SIZE = 24
const PAGE_NUM = 1
function Component({ category, id }) {
  const [data, setData] = useState(category)
  const [listLeagues, setListLeagues] = useState(category.list_league)
  const [activeLeague, setActiveLeague] = useState(null)
  const [scroll, setScroll] = useState(null)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 640) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 100) {
        setScroll(true)
      } else {
        setScroll(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  let isDragging = false
  let startX

  function handleDragStart(e) {
    e.preventDefault()
    isDragging = true
    startX = e.pageX || e.touches[0].pageX
  }

  function handleDrag(e) {
    if (!isDragging) return
    const x = e.pageX || e.touches[0].pageX
    const scrollLeft = e.currentTarget.scrollLeft
    e.currentTarget.scrollLeft = scrollLeft - (x - startX)
    startX = x
  }

  function handleDragEnd() {
    isDragging = false
  }

  const [pageNum, setPageNum] = useState(PAGE_NUM)
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const loaderRef = useRef(null)

  const fetchData = async (page) => {
    setLoading(true)
    try {
      const { data } = activeLeague
        ? await api.getDetailCategory(getAccessToken(), id, {
            league_id: activeLeague,
            page_num: page,
            page_size: PAGE_SIZE
          })
        : await api.getDetailCategory(getAccessToken(), id, { page_num: page, page_size: PAGE_SIZE })
      setData(data)

      const newItems = data?.videos || []
      setItems((prev) => [...prev, ...newItems])

      if (newItems.length < PAGE_SIZE) {
        setHasMore(false)
      }
    } catch (err) {
      console.error("Lỗi:", err)
      setHasMore(false)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (hasMore && pageNum !== PAGE_NUM) {
      fetchData(pageNum)
    }
  }, [pageNum])

  useEffect(() => {
    if (!hasMore) return

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !loading) {
        setPageNum((prev) => prev + 1)
      }
    })

    const loader = loaderRef.current
    if (loader) observer.observe(loader)

    return () => {
      if (loader) observer.unobserve(loader)
    }
  }, [loading, hasMore])

  useEffect(() => {
    setItems([])
    setHasMore(true)
    fetchData(PAGE_NUM)
  }, [activeLeague, id])

  useEffect(() => {
    setListLeagues(category?.list_league)
    setActiveLeague(null)
  }, [category])

  return (
    <section className="mb-[46px] 3xl:ml-0 max-sm:mr-0 max-sm:ml-0 max-lg:mr-4 max-lg:ml-4 xl:mr-8 md:mx-4">
      <div className="wapper__slide">
        <MyImage
          name={data?.name}
          thumbnail={data?.thumbnail}
          description={data?.description}
          backgroundColor={data?.background_color}
          scroll={scroll}
          isMobile={isMobile}
        />
      </div>

      <div
        className={classNames(
          "list-game-container draggable flex gap-2 font-bold mt-6 sticky z-30 bg-[#131313] py-2 max-sm:mt-0 max-lg:top-[58.75px] max-lg:mt-5",
          !isMobile ? "items-center top-[60px] xl:top-[83.75px]" : " flex-col top-[58.75px] max-sm:px-4"
        )}
        onMouseDown={(e) => handleDragStart(e)}
        onMouseMove={(e) => handleDrag(e)}
        onMouseUp={() => handleDragEnd()}
        onMouseLeave={() => handleDragEnd()}
      >
        {isMobile ? (
          <>
            {scroll && <div className="font-semibold text-2xl text-[#fafaf9] truncate">{data?.name}</div>}
            <div className="flex overflow-x-auto gap-2 scrollbar-hide scroll-smooth">
              <button
                className={classNames(
                  "flex-shrink-0 flex items-center justify-center list-game__background rounded-[44px] text-base font-medium py-2 px-4 gap-2 border border-[#5F5F5F] whitespace-nowrap",
                  {
                    "list-game__background--active": activeLeague === null
                  }
                )}
                onClick={() => setActiveLeague(null)}
              >
                {activeLeague === null ? (
                  <img src="/icons/iconDocumentBlue.svg" />
                ) : (
                  <img src="/icons/iconDocument.svg" />
                )}{" "}
                <span className={activeLeague != null && "max-sm:hidden"}>Tất cả</span>
              </button>
              {listLeagues?.map((league) => (
                <button
                  className={classNames(
                    "flex-shrink-0 flex items-center justify-center list-game__background rounded-[44px] text-base font-medium py-2 px-4 gap-2 border border-[#5F5F5F] whitespace-nowrap",
                    {
                      "list-game__background--active": activeLeague === league?.id
                    }
                  )}
                  key={league?.id}
                  onClick={() => setActiveLeague(league?.id)}
                >
                  <img
                    src={activeLeague === league?.id ? league?.logo_active : league?.logo_inactive}
                    width={24}
                    height={24}
                  />
                  <span className={activeLeague != league?.id && "max-sm:hidden"}>{league?.name}</span>
                </button>
              ))}
            </div>
          </>
        ) : (
          <>
            <>
              <button
                className={classNames(
                  "flex items-center justify-center list-game__background rounded-[44px] text-base font-medium py-2 px-4 gap-2 border border-[#5F5F5F] whitespace-nowrap",
                  {
                    "list-game__background--active": activeLeague === null
                  }
                )}
                onClick={() => setActiveLeague(null)}
              >
                {activeLeague === null ? (
                  <img src="/icons/iconDocumentBlue.svg" />
                ) : (
                  <img src="/icons/iconDocument.svg" />
                )}{" "}
                <span>Tất cả</span>
              </button>
              {listLeagues?.map((category) => (
                <button
                  className={classNames(
                    "flex items-center justify-center list-game__background rounded-[44px] text-base font-medium py-[2px] px-4 gap-2 border border-[#5F5F5F] whitespace-nowrap",
                    {
                      "list-game__background--active": activeLeague === category?.id
                    }
                  )}
                  key={category?.id}
                  onClick={() => setActiveLeague(category?.id)}
                >
                  <img
                    src={activeLeague === category?.id ? category?.logo_active : category?.logo_inactive}
                    width={36}
                    height={36}
                    alt=""
                  />
                  <span>{category?.name}</span>
                </button>
              ))}
            </>
          </>
        )}
      </div>
      <div className="mx-auto overflow-x-hidden mt-8 max-sm:mt-2 max-sm:px-4">
        {data?.events?.length > 0 && (
          <SwiperVideo
            name={"Sự kiện"}
            videos={[...data.events].sort((a, b) => (b.status === "live") - (a.status === "live"))}
            type_block={1}
          />
        )}
        {items?.length > 0 && (
          <div className="flex flex-col gap-3.5">
            <span className="text-[24px] leading-[30px] text-white font-semibold max-sm:text-[16px]">Video</span>
            <div className={"grid grid-cols-4 gap-6 max-sm:grid-cols-1 max-lg:grid-cols-3 max-lg:gap-3"}>
              {items?.length > 0 &&
                items?.map((item) => {
                  const { id, type } = item
                  return (
                    <CardHorizontal
                      {...item}
                      display_type={0}
                      showTime={false}
                      key={id}
                      nextLink={`/video?id=${id}&type=${type}`}
                      customGrid={true}
                    />
                  )
                })}
            </div>
          </div>
        )}

        {hasMore && (
          <div ref={loaderRef} className="h-10 text-center text-sm text-gray-500">
            {loading ? "Đang tải dữ liệu..." : ""}
          </div>
        )}

        {!data?.events && !data?.videos && (
          <div className="flex flex-col gap-2 items-center justify-center py-[193px] text-center">
            <span className="text-[22px] leading-[30px] font-semibold text-white">Nội dung chưa sẵn sàng</span>
            <span className="text-base leading-5 font-normal text-[#c6c6c8]">
              Chúng tôi đang cập nhật nội dung này. Bạn có thể thử lại sau một thời gian nữa.
            </span>
          </div>
        )}
      </div>
    </section>
  )
}
export default Component
Component.Layout = Layout

function renderUrl(base_url, thumbnail, size) {
  if (thumbnail?.includes("http")) return thumbnail
  if (!thumbnail) return "/placeholder_video.svg"
  return `${base_url}${size}/${thumbnail}`
}

function MyImage({ base_url, thumbnail, name, description, backgroundColor, scroll, isMobile }) {
  return (
    <div className="relative rounded-3xl overflow-hidden max-sm:rounded-none">
      <div
        className="w-full h-[132px] max-sm:h-[42px] absolute bottom-0 left-0"
        style={{
          background: `linear-gradient(180deg, transparent 0%, ${backgroundColor} 84.66%, ${backgroundColor} 100%)`
        }}
      ></div>
      <div className="absolute bottom-0 left-0 w-full">
        <div className="flex flex-col w-full gap-1 px-5 pb-5 max-sm:pb-3 max-sm:px-3">
          {(!scroll || !isMobile) && (
            <div className="font-semibold text-2xl text-[#fafaf9] max-sm:line-clamp-1">{name}</div>
          )}
          <div className="font-normal text-sm text-secondary line-clamp-1 max-sm:hidden">{description}</div>
        </div>
      </div>

      <div className="fix_img">
        <img
          placeholder="blur"
          className="w-full rounded-3xl h-[358px] object-cover max-sm:rounded-none"
          src={renderUrl(base_url, thumbnail, "1920x800") || "/placeholder_banner.svg"}
          width={1578}
          height={358}
          alt={name}
        />
      </div>
    </div>
  )
}

export async function getServerSideProps({ req, query, res }) {
  res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=29")
  let category = {}

  const { cookies } = req
  const { id } = query

  try {
    const { success, data } = await api.getDetailCategory(cookies?.accessToken, id)
    if (data) {
      category = data
    }
  } catch (error) {
    // console.log(error.response)
  }

  return { props: { category, id } }
}
